export const GB_KEYS = {
  // Enable access to third party orders (WYN-50898)
  ADMIN_ORDERS_THIRD_PARTY_CLAIM: 'admin-orders-third-party-claim',
  // Customer Registration - verify by SMS (WYN-41608)
  ACCOUNT_CONFIRMATION_BY_SMS_ENABLED: 'account-confirmation-by-sms-enabled',
  // Slot Templates List View - Bulk actions - Cutoff Time (WYN-57069)
  BULK_ACTION_CUTOFF_SLOTS: 'dev-admin-bulk-cutoff-slots',
  // Slot Management - Bulk blocking slots Route (WYN-49006)
  BULK_BLOCKING_SLOTS: 'admin-bulk-blocking-slots',
  // Past Purchases - Is between (custom date range) for Recommendations and Listings (WYN-57007)
  PAST_PURCHASES_DATE_RANGE: 'admin-past-purchases-date-range',
  // Order Details - Hide Edit Fulfilment Info button for LMD third-party delivery (WYN-58458)
  HIDE_FULFILMENT_INFO_EDIT: 'admin-hide-fulfilment-info-edit',
  // Order Fulfillment - Pick Status All FCs (WYN-45125)
  VIEW_ALL_FULFILLMENT_CENTER_STATISTICS: 'view-all-fulfillment-center-statistics',
  // Order Fulfillment - Allow Single Pick Unique ID (WYN-60144)
  ORDER_FULFILLMENT_ALLOW_SINGLEPICK_UNIQUEID: 'order-fulfillment-allow-singlepick-uniqueid',
  // Paginated Recommendation Carousels (WYN-47301)
  PAGINATED_RECOMMENDATIONS_ENABLED: 'recommendations_pagination_enabled',
  // Inmar Ad Media CMS component (WYN-62719)
  AD_MEDIA_ENABLED: 'ad-media-enabled',
  // Promotion Gallery dedicated image field (WYN-60597)
  PROMO_GALLERY_IMAGE: 'enable-promo-gallery-image',
  // Failed Submissions - Zetes menu visibility (WYN-63927)
  ZETES_FAILED_SUBMISSIONS_ENABLED: 'admin-zetes-failed-submissions',
  // Delivery Integration API not available for this environment (WYN-66101)
  DELIVERY_INTEGRATION_DISABLED: 'delivery-integration-disabled',
  // Order Fulfillment API not available for this environment (WYN-83996)
  ORDER_FULFILLMENT_DISABLED: 'order-fulfillment-disabled',
  // Subscriptions API not available for this environment (WYN-83996)
  CUSTOMER_SUBSCRIPTIONS_DISABLED: 'customer-subscriptions-disabled',
  // CRM - Edit customer contact details and loyalty (WYN-67179)
  CRM_EDIT_CUSTOMER_INFO: 'crm-edit-customer-info-enabled',
  // Admin Panel - New Promotion Types UI (Weighted Product, Fixed Price WYN-28832)
  ADMIN_PROMOTION_ENHANCEMENTS: 'dev-admin-promotion-enhancements',
} as const;
